<div class="brand">
  <a routerLink="/" class="logo" aria-label="Ir para a página inicial da Lista Vermelha">
    <img src="assets/brand/lista-vermelha/logo/lista-vermelha-horizontal.svg" alt="Lista Vermelha de espécies ameaçadas de Minas Gerais" class="brand-logo"/>
  </a>
</div>
